import { render, staticRenderFns } from "./KnProductBrands.vue?vue&type=template&id=fa3707ac&"
import script from "./KnProductBrands.vue?vue&type=script&lang=js&"
export * from "./KnProductBrands.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports